import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import * as Constants from '@emi/shared/constants';
import { CapsuleDto } from 'libs/sku-capsule/feature/sku-summary/src/lib/models';

@Injectable({
    providedIn: 'root'
})
export class SkuCapsuleService {

    constructor(private httpService: HttpService) { }

    public getSkuCapsule(emiItemId: number): Observable<CapsuleDto> {
        return this.httpService.getHttp<CapsuleDto>(
            `${Constants.ServiceConstants.SKUS}/${emiItemId}/capsule`
        );
    }
}
